export const environment = {
    staging:true,
    baseUrl:process.env.DEV_BASE_URL,
    fingerprintUrl: process.env.DEV_FINGERPRINT_URL,
    sdkUrl: process.env.SDKURL_STARTEK,
    siteKey: process.env.DEV_SITEKEY,
    dsn: 'https://49180b648ace4b53a2c22a334c99edc7@o1145469.ingest.sentry.io/6454404',
  };